import request from 'superagent';
import { UPLOAD_PDFS, SELECT_TEMPLATES, UPDATE_TEXT } from './types';

import { root } from '../constants';

// action for sending pdfs to the server
export function uploadPdfs(values, selected_templates, callback) {
  const acceptedFiles = values;

  const req = request.post(`${root}/api/data`);

  // field where the templates can be attached
  for (var i = 0; i < selected_templates.length; i++) {
    const template = selected_templates[i];
    req.field('template_' + i, template);
  }

  // attached each file with its name
  acceptedFiles.forEach(file => {
    req.attach(file.name, file);
  });

  // alert when the file processing is finished
  req.then(callback);

  // using redux-thunk, directly retrieve the body of the response
  // and give as payload
  return dispatch => {
    req.then(({ body }) => {
      dispatch({
        type: UPLOAD_PDFS,
        payload: body
      });
    });
  };
}

// action for handling selected template updates
export function selectTemplates(opts) {
  const template_selected = opts.map(opt => opt.value);

  return {
    type: SELECT_TEMPLATES,
    // in payload, just need to assign what is originally
    // "return" in a normal function
    payload: template_selected
  };
}

// update the text when changed
export function updateText(text) {
  return {
    type: UPDATE_TEXT,
    payload: text
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js